import { render, staticRenderFns } from "./ManageUserPage.vue?vue&type=template&id=ae855ab4"
import script from "./ManageUserPage.vue?vue&type=script&lang=ts"
export * from "./ManageUserPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports